// ----------------- Common Library -----------------
export {API, axios, Button, ButtonStyle, Checkbox, ErrorMessage,
    faExclamationCircle, faTimes, Field, FieldArray, FontAwesomeIcon, Form,
    Formik, FormikControl, FormStyle, getIn, getSession, Image, Link, NextServerCookies,
    React, REDIRECT, Select, Sidebar, signIn, SUCCESS_REPONSE_CODE, toastr, TRANSLATION,
    UNPROCESSABLE_ENTITY_RESPONSE_CODE, useEffect, useRouter, useState, useSWR, useTranslation,
    Yup, SendRequest, useRef, CustomToastrAction, ErrorPages, Loading, InputError, CommonAction, Tooltip} from '@/imports-files/common/common';

// ----------------- Common Library -----------------

// ----------------- Components ---------------    
export { Header}  from '@/components/careers/header';
export { HeroSection } from '@/components/careers/hero-section';
export { OpenJobs } from '@/components/careers/open-jobs';
export { Footer } from '@/components/careers/footer';
export { TestSection } from '@/components/careers/test-section';
export { SidePanel } from '@/components/careers/side-panel';
export { AddSection } from '@/components/careers/add-section/add-section';
export { AboutSection } from '@/components/careers/add-section/about';
export { GallerySection } from '@/components/careers/add-section/gallery';
export { BenfitSection } from '@/components/careers/add-section/benefit';
export { MeetTeamSection } from '@/components/careers/add-section/meet_our_team';
export { ReOrderSection } from '@/components/careers/add-section/reorder';
export { About } from '@/components/careers/about';
export { Gallery } from '@/components/careers/gallery';
export { Benefit } from '@/components/careers/benefit';
export { MeetTeam } from '@/components/careers/meet-our-team';
export { ButtonCustomizationModal } from '@/components/careers/button-customization-modal';
export { SocialLinkModal } from '@/components/careers/social-link-modal';

export { HeaderLinks } from '@/components/careers/navigation-section/header-links';
export { FooterLinks } from '@/components/careers/navigation-section/footer-links';
export { SocialLinks } from '@/components/careers/navigation-section/social-links';


export { CustomButtons } from '@/components/careers/button-section/buttons-style';
export { HeroTitle } from '@/components/careers/font-section/hero-title';

export { CustomCropper } from "@/components/custom-cropper";
export { CareerCropper } from "@/components/career-cropper";

export { ConfirmationModal } from '@/components/confirmation-modal';

// ----------------- CSS ----------------
export { default as PageStyle } from '@/styles/pages/career/customize-career-page/_index.module.scss';
export {default as InputStyle} from '@/styles/components/input-field/_index.module.scss';

//------------------Service------------
export { CustomizeCareerService } from '@/services/pages/clients/careers/customize-career-page';

//------------------Actions------------
export { CustomizeCareerAction } from '@/actions/pages/clients/careers/customize-career-page';
export { CustomCropperAction} from "@/actions/components/custom-cropper";
export { ShowJobAction } from '@/actions/pages/clients/careers/showJob';

//------------------Helper Components--------
export { default as EdiText } from 'react-editext';
export { default as EditImage } from '@/pages/careers/editimage';

//------------------Constants----------
export { LINK_TYPES, DEFAULT_JOBS, FILE_SIZES, IMAGE_VISIBILITIES, BUTTON_STYLES_OPTIONS, TEXT_STYLES_OPTIONS, BENEFIT_DATA, TEAM_DATA, TEAM_NO_DATA, URL_FORMAT, fonts, fontOptions} from '@/constants/pages/clients/careers/customize-career-page';
export { INITIAL_VALUES } from '@/constants/pages/clients/careers/showJob.js';

//-------------- Image Components ------

export {default as EditBannerIcon} from '/public/icons/career_icons/edit-banner.svg';
import {default as CloseEyeIcon} from 'public/icons/career_icons/eye-close.svg';
export { default as GreyGripIcon } from 'public/icons/grey_gripicon.svg';
//---------------Drag and Drop Components
export { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

export { default as GoogleFontLoader } from 'react-google-font-loader';
